import spanishLanguage from 'antd/lib/locale/es_ES';
import englishLanguage from 'antd/lib/locale/en_US';

const languageOptions = {
  es: spanishLanguage,
  en: englishLanguage
};

export default languageOptions;
